<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Resource List</h3>
      </div>
    </div>
  </div>
</div>

<table id="resList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead class="thead-dark">
    <tr>
      <th>No</th>
      <th>Title</th>
      <th>Link</th>
      <th>Remark</th>
    </tr>
 </thead>
  <tbody>
    <tr *ngFor="let item of list; index as i;">
      <td>{{i + 1}}</td>
      <td>{{item.title}}</td>
      <td><a target="_blank" href="{{item.link}}">{{item.link}}</a> </td>
      <td>{{item.remark}}</td>
    </tr>
  </tbody>
</table>

